import { createSlice } from "@reduxjs/toolkit";

export const DashboardMessagesSlice = createSlice({
  name: "DashboardMessages",
  initialState: {
    showMessage: true,
    messages: [],
  },
  reducers: {
    setDashboardMessages: (state, { payload }) => {
      state.messages = payload;
    },
    setMessageShow: (state, { payload }) => {
      state.showMessage = payload;
    },
  },
});

export const { setDashboardMessages, setMessageShow } = DashboardMessagesSlice.actions;

export const DashboardMessagesReducer = DashboardMessagesSlice.reducer;
